/* @flow */

import { callLiferayEndpoint } from './index';
import utils from './utils';

import type { Channel } from 'types';

const find = async (broadcastingId: number): Promise<Channel[]> => {
  const response = await callLiferayEndpoint(
    '/protones-portlet.canali/find-by-organization-id-deep',
    {
      organizationId: broadcastingId,
    }
  );
  return response.map(utils.toChannel);
};

export default {
  find,
};
